import {LOCATE_HIDE_FOOTER} from "../types";

const hideFooter = (visible) => {
  return ({type: LOCATE_HIDE_FOOTER, payload: {hideFooter: visible}});
};

export default hideFooter;